import styles from "./CircleButton.module.css";
const CircleButton = ({
  children,
  size = "30px",
  color = "#3690ff",
  backgroundColor = "#F1F2F3",
  ...props
}: any) => {
  return (
    <button
      className={styles.CircleButton}
      style={{
        width: size,
        height: size,
        color: color,
        backgroundColor: backgroundColor,
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export default CircleButton;
